// extracted by mini-css-extract-plugin
export default {"menu_button":"styles_menu_button__bC6im","template_setting_menu":"styles_template_setting_menu__09YCd","flex_end":"styles_flex_end__bv0Vz"};